import httpClient, { httpClientWithoutLoading } from "./index";

const END_POINT = "unit-models";

const floors = () => httpClient.get(END_POINT);
const floorsQuery = () => httpClientWithoutLoading.get(END_POINT);

export { floors, floorsQuery };
